/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import React, { useContext } from "react";
import { Box, Typography, Link, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SidebarContext } from "../sidebar/context/sidebar.context";
import useAuthorized from "../../../hooks/use-authorized.hook";
import { DRAWER_WIDTH_EXPANDED, DRAWER_WIDTH_COLLAPSED, FOOTER_HEIGHT } from "../sidebar/sidebar";
import { APP_VERSION } from "../../../configs/constants";

const Footer = () => {
  const { t } = useTranslation();
  const sidebar = useContext(SidebarContext);
  const isAuthorised = useAuthorized();
  const theme = useTheme();
  const showSidebar = isAuthorised;

  return (
    <Box
      component="footer"
      sx={{
        position: "fixed",
        bottom: 0,
        left: showSidebar
          ? (sidebar.opened ? `${DRAWER_WIDTH_EXPANDED}px` : `${DRAWER_WIDTH_COLLAPSED}px`)
          : 0,
        right: 0,
        height: `${FOOTER_HEIGHT}px`,
        boxSizing: "border-box",
        px: 2,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        flexWrap: "nowrap",
        backgroundColor: (theme) => theme.palette.background.default,
        zIndex: 1300,
        transition: theme.transitions.create(["left"], {
          easing: "cubic-bezier(0.4, 0, 0.2, 1)",
          duration: 400,
        }),
      }}
    >
      <Typography
        sx={{
          fontSize: "0.7rem",
          color: "text.secondary",
          whiteSpace: "nowrap",
        }}
      >
        {APP_VERSION}
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ fontSize: "0.75rem", whiteSpace: "nowrap", flex: 1, textAlign: "center" }}>
        {t("footer.note")}
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ fontSize: "0.75rem", whiteSpace: "nowrap" }}>
        &copy; {new Date().getFullYear()}{" "}
        <Link
          href="https://kaimakiweb.com"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: "inherit",
            textDecoration: "underline",
            "&:hover": { textDecoration: "underline" },
          }}
        >
          Kaimakiweb.com
        </Link>{" "}
        All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
